

















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
import storage from 'baimahu/storage';
const getUrl = require('bmh/url-with-param');
const { VUE_APP_FCREST: FCREST } = process.env;
interface BatchConfig {
  page_view_target: number;
  apply_target: number;
  commodity_target: number;
}

const _ = {
  each: require('lodash/each'),
};

function getBatchConfigModal(): BatchConfig {
  return {
    page_view_target: 0,
    apply_target: 0,
    commodity_target: 0,
  };
}

function getPaginationData(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    data: remote.data || [],
    last: remote.last || 0,
    size: remote.size || 0,
    total: remote.total || 0,
  };
}

function noClerkInfo() {
  return {
    clerk_mobile: '',
    apply_number: 0,
    apply_target: 0,
    page_view: 0,
    page_view_target: 0,
    commodity_target: 0,
    specify_ware_order_number: 0,
  };
}

const API = {
  query_or_edit: `${FCREST}/promotion/shang/clerk/target`, // 查询分销员; /999999批量目标设置; /:id单个目标设置
  query_first_clerk: `${FCREST}/setting/shang/clerk/search`, // 查询一级分销员
};
@Component
export default class ActivityTarget extends Vue {
  activity_id: number = 0;
  active_index: number | string = '';
  active_field: string = '';
  batch_config_modal_value: BatchConfig = getBatchConfigModal();
  first_clerk_list: any = [];
  is_loading: boolean = false;
  is_show_batch_config: boolean = false;
  level_one_clerk_data: any = getPaginationData();
  level_two_clerk_data: any = getPaginationData();
  level: number = 0;
  parent_clerk: string | number = '';
  user_field_content: string = '';

  // 归属一级搜索
  async queryFirstClerk(name?: string) {
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    const res = await this.$axios.get(
      getUrl(API.query_first_clerk, {
        merchant_id,
        level: 1,
        name,
      }),
    );
    this.first_clerk_list = [];
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.first_clerk_list = res.data.data;
  }

  async query(send_data?: any) {
    // clerk_level为1时表示一级目标，为2时表示二级目标；order_type排序方式; order_field排序字段
    this.is_loading = true;
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    const res = await this.$axios.get(
      getUrl(API.query_or_edit, {
        activity_id: send_data.activity_id || '',
        page: send_data.page || '',
        clerk_level: send_data.clerk_level || '',
        clerk_id: send_data.clerk_id || '',
        order_field: send_data.order_field || '',
        order_type: send_data.order_type || '',
        merchant_id,
      }),
    );
    this.is_loading = false;
    _.each(res.data.data.data, (item: any) => {
      if (!item.clerk_info) {
        item.clerk_info = noClerkInfo();
      }
    });
    send_data.clerk_level === 1
      ? (this.level_one_clerk_data = getPaginationData())
      : (this.level_two_clerk_data = getPaginationData());
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    if (send_data.clerk_level === 1) {
      this.level_one_clerk_data = getPaginationData();
      this.level_one_clerk_data = getPaginationData(res.data.data);
    } else {
      this.level_two_clerk_data = getPaginationData();
      this.level_two_clerk_data = getPaginationData(res.data.data);
    }
  }

  // 查询分销员
  queryClerk() {
    const send_data = {
      activity_id: this.activity_id,
      clerk_level: 1,
      page: 1,
      clerk_id: this.parent_clerk,
    };
    this.query(send_data);
  }

  // 批量设置目标
  async batchSetTarget(level: number) {
    this.is_loading = true;
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    const res = await this.$axios.put(`${API.query_or_edit}/999999`, {
      activity_id: this.activity_id,
      ...this.batch_config_modal_value,
      clerk_level: level,
      merchant_id,
    });
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const send_data = {
      activity_id: this.activity_id,
      clerk_level: level,
    };
    await this.query(send_data);
    this.$message.success('批量设置目标成功');
  }

  // 单个设置目标
  async setTarget(
    clerk_id: number,
    update_field: string,
    count: number,
    level: number,
  ) {
    this.is_loading = true;
    const send_data = {
      activity_id: this.activity_id,
      update_field,
      number: count,
      clerk_level: level,
    };
    const res = await this.$axios.put(
      `${API.query_or_edit}/${clerk_id}`,
      send_data,
    );
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('目标设置成功');
  }

  // 输入框失去焦点，编辑完成
  editFinish(record: any, field: string) {
    this.active_index = '';
    this.active_field = '';
    this.setTarget(record.id, field, record.clerk_info[field], record.level);
  }

  async created() {
    await this.queryFirstClerk();
    this.activity_id = +this.$route.query.activity_id;
    const send_data1 = {
      activity_id: this.activity_id,
      clerk_level: 1,
    };
    const send_data2 = {
      activity_id: this.activity_id,
      clerk_level: 2,
    };
    await this.query(send_data1);
    await this.query(send_data2);
  }

  // 更改模态窗在dom结构中的位置
  getPopupContainer() {
    return document.getElementById('activity-target');
  }

  paginationOptions(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.size}条`,
      pageSize: data.size || 1,
      current: data.current || 1,
    };
  }

  // 编辑数量
  editNumber(record: any, field: string, index: number) {
    this.active_index = index;
    this.active_field = field;
  }

  // 点击批量设置按钮
  clickBatchConfig(level: number) {
    this.is_show_batch_config = true;
    this.level = level;
    this.user_field_content = level === 1 ? '所有一级分销员' : '二级分销员';
  }

  // 批量更新目标
  updateTarget() {
    this.batchSetTarget(this.level);
    this.closeBatchConfigModal();
  }

  // 关闭批量设置
  closeBatchConfigModal() {
    this.batch_config_modal_value = getBatchConfigModal();
    this.is_show_batch_config = false;
  }

  // table排序方法
  tableSort(a: any, b: any) {
    return a.id - b.id;
  }

  // 限制输入框只能输入正整数
  limitNum(val: any, field: string) {
    val[field] = Math.floor(Math.abs(val[field])) || 0;
  }
}
